/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityLikeDto } from '../../models/community-like-dto';

export interface CommunityLikeControllerFindByUserId$Params {
}

export function communityLikeControllerFindByUserId(http: HttpClient, rootUrl: string, params?: CommunityLikeControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityLikeDto>>> {
  const rb = new RequestBuilder(rootUrl, communityLikeControllerFindByUserId.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityLikeDto>>;
    })
  );
}

communityLikeControllerFindByUserId.PATH = '/api/community-like/my';
